import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAkVu2cdbgSYC3HsFe2OoIhqhi0PSbW324",
  authDomain: "manish-portfolio-e5cbf.firebaseapp.com",
  projectId: "manish-portfolio-e5cbf",
  storageBucket: "manish-portfolio-e5cbf.appspot.com",
  messagingSenderId: "1005980085443",
  appId: "1:1005980085443:web:1a7a829025ea96cc7a8676"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore();
